import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ColorPickerPage } from './color-picker.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'color-picker',
        component: ColorPickerPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [ColorPickerPage],
    exports: [ColorPickerPage]
})
export class ColorPickerPageModule {}
